import React from 'react';
import PropTypes from 'prop-types';

import { SubHeader } from 'cstar-react-primitives';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { useFormatMessage } from '../../intl/intlHooks';
import { orderSummaryTotalPointsMessages } from './orderSummaryMessages';

import { useUsers } from "../../user/UserContext";

export const OrderSummaryTotalsPoints = (props) => {
    const { totalValue } = props;
    const formatMessage = useFormatMessage();
    const { userData } = useUsers();

    return (
        <div className="order-summary-totals">
            <SubHeader heading={formatMessage(orderSummaryTotalPointsMessages.orderSummaryLabel)} />
            <div className="order-summary-totals-line">
                <div className="order-summary-totals-label">
                    <FormattedMessage {...orderSummaryTotalPointsMessages.availableFlexDollars} />
                </div>
                <div className="order-summary-totals-value">
                    <FormattedNumber value={userData.availableAmount} format="currency" />
                </div>
            </div>
            <div className="order-summary-totals-line">
                <div className="order-summary-totals-label">
                    <FormattedMessage {...orderSummaryTotalPointsMessages.cardValue} />
                </div>
                <div className="order-summary-totals-value">
                    <FormattedNumber value={totalValue} format="currency" />
                </div>
            </div>
            <div className="order-summary-totals-line">
                <div className="order-summary-totals-label">
                    <FormattedMessage {...orderSummaryTotalPointsMessages.afterPurchaseBalance} />
                </div>
                <div className="order-summary-totals-value">
                    <FormattedNumber value={userData.availableAmount - totalValue} format="currency" />
                </div>
            </div>
            <div className="order-summary-totals-line order-summary-totals-total">
                <div className="order-summary-totals-label">
                    <FormattedMessage {...orderSummaryTotalPointsMessages.pointsTotalAmountDue} />
                </div>
                <div className="order-summary-totals-value">
                    <FormattedNumber value={totalValue} format="currency" />
                </div>
            </div>
        </div>
    );
};

OrderSummaryTotalsPoints.propTypes = {
    totalValue: PropTypes.number.isRequired,

};
